<style lang="scss" scoped>
  @import '../../../sass/variables';

  .sidebar {
    transition: 250ms;
    padding: 30px 20px;
    margin-left: -15px;
    position: absolute;
    right: 0px;
    height: calc(100% - 12.25rem);
    border-top-left-radius: 16px;
    border-bottom-left-radius: 16px;

    .sidebar-header {
      color: $salesflow-font-gray;
      position: relative;

      .title {
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.6;
        letter-spacing: -0.27px;
        margin-bottom: 2px;
      }

      .subtitle {
        letter-spacing: -0.18px;
        margin-bottom: 30px;
      }

      .subtitle a {
        color: $salesflow-font-gray;
        font-weight: 700;
      }

      .delete {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 9;

      }
      .delete ::v-deep svg {
        width: 16px;
        height: 16px;

        path {
          fill: $salesflow-font-gray !important;
        }

        &:hover {
          path {
            fill: $salesflow-danger-hover !important;
          }
        }
      }
    }
    .form-control {
      height: 52px;
      background-color: $white;
      color: $salesflow-font-dark;
      border: 1px solid $salesflow-outline-gray-medium;
      border-radius: 8px;
      font-size: 1rem;
    }
  }

  .preview {
    width: 259px;
    height: 259px;
    margin-bottom: 10px;
  }

  .btn-cancel {
    color: $salesflow-font-gray;
    font-size: 0.75rem;
    font-weight: 600;

    &:hover {
      color: $salesflow-primary-hover;
    }
  }
</style>

<template>
  <div
    class="sidebar bg-white shadow"
    id="sidebar"
    v-if="file !== false"
  >
    <div class="sidebar-header text-center">
      <h2 class="title">
        {{ __('Editar material') }}
      </h2>
      <div class="subtitle">
        <a
          href="#"
          v-b-tooltip.bottom="'Copiar URL'"
          :data-clipboard-text="file.url"
          ref="copy"
        ><img
          class="mr-2"
          src="/build/icons/copy.svg"
        >{{ __('Copiar URL') }}</a>
      </div>
      <a
        class="delete mt-1"
        href="#"
        v-b-tooltip.bottom="'Excluir'"
        @click.prevent="destroy"
      >
        <IconTrash /></a>
    </div>
    <div class="sidebar-content">
      <Preview
        class="preview"
        :file="file"
        :svgComponent="file.svgComponent"
        large="large"
      />
      <div class="form-group mt-4 title">
        <label>{{ __('Título') }}</label>
        <input
          class="form-control"
          v-model="file.title"
        >
      </div>
      <div class="d-inline-table mt-30px">
        <div class="text-center">
          <button
            class="btn btn-primary f-w-600 salesflow-btn-border salesflow-btn-save"
            type="button"
            @click.prevent="update"
          >
            {{ __('Salvar') }}
          </button>
        </div>
        <div class="text-center">
          <button
            class="btn btn-cancel f-w-600"
            type="button"
            aria-label="Close"
            @click.prevent="close"
          >
            <u>{{ __('Cancelar') }}</u>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue';
import Preview from './MaterialPreview.vue';
import { Confirm } from '../../services/Confirm';

export default {
  components: {
    Preview,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data () {
    return {
      file: false,
      clip: false,
    };
  },

  mounted () {
    Bus.$on('editFile', (file) => this.editFile(file));
    Bus.$on('hideEditFile', () => this.file = false);
  },

  methods: {
    editFile (file) {
      if (this.clip) {
        this.clip.destroy();
      }

      this.file = file;

      this.$nextTick(() => {
        this.clip = (new ClipboardJS(this.$refs.copy)).on('success', () => {
          Alert.success(this.__('Link copiado!'));
        });

        setTimeout(() => this.$refs.copy.click(), 300);
      });
    },

    async destroy () {
      if (await Confirm(this.__('Confirmar exclusão?'))) {
        Bus.$emit('deleteFile', this.file.id, this.close());
      }
    },

    update () {
      Bus.$emit('updateFile', this.file.id, this.file.title, this.close());
    },

    close () {
      Bus.$emit('hideEdit');
    },
  },
};
</script>
